// Generated by Melange

import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Checkbox from "../../components/html/Checkbox.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__RadioButton from "../../components/html/RadioButton.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ContractCreatePage(Props) {
  let org = Props.org;
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Новый договор"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: {
                                    TAG: /* Org */6,
                                    _0: org.id,
                                    _1: {
                                      TAG: /* Documents */1,
                                      _0: {
                                        TAG: /* Contracts */0,
                                        _0: /* List */0
                                      }
                                    }
                                  },
                                  children: JsxRuntime.jsx("img", {
                                        src: StaticAsset.src("/static/icons/close-20.svg")
                                      })
                                }),
                            className: "bg-white py-4.5 px-6 border-b border-gray-main w-full"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                    className: "mb-4 text-default-gray",
                                    children: "Договор"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Шаблон договора"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    className: "rounded border",
                                                    src: StaticAsset.src("/static/icons/dogovor.svg")
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                            className: "mb-1",
                                                            children: "Договор #ЧК-BUHTA-01"
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                            className: "text-gray-medium",
                                                            children: "Основной договор"
                                                          })
                                                    ],
                                                    className: "flex-col gap-1 "
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                    alt: "arrow-buhta",
                                                    src: StaticAsset.src("/static/icons/Arrows.svg")
                                                  })
                                            ],
                                            className: "flex gap-3 w-112 px-4 py-3 border rounded relative"
                                          })
                                    ],
                                    className: "flex w-158 justify-between mb-4 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Направление"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    checked: true,
                                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          children: "От нас"
                                                        })
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    className: "ml-5",
                                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          children: "Входящий"
                                                        })
                                                  })
                                            ],
                                            className: "flex w-112"
                                          })
                                    ],
                                    className: "flex w-158 justify-between mb-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Наименование"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            size: "m",
                                            className: "w-112",
                                            value: "Разработка дизайна корпоративного сайта"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "mt-4 text-black",
                                            children: "Номер"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-112 mb-1",
                                                    value: "ЧК-BUHTA-01"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                    className: "w-110 text-gray-medium",
                                                    children: "Если номер не последовательный или договор входящий, введите свой номер (последовательный все равно будет назначен, но использоваться будет введенный вами)."
                                                  })
                                            ],
                                            className: "flex-row"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 "
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Дата"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            size: "m",
                                            className: "w-112",
                                            value: "30.01.2022"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "mt-4 text-black",
                                            children: "Сроком до "
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-112 mb-2",
                                                    value: "30.01.2022"
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                    text: "Автоматическая пролонгация"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Кому"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    placeholder: "Введите имя или выберите из списка",
                                                    size: "m",
                                                    className: "w-112"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                    alt: "arrow-buhta",
                                                    src: StaticAsset.src("/static/icons/Arrows.svg")
                                                  })
                                            ],
                                            className: "relative"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Счет"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-112 ",
                                                    value: "KZ4829493091391039"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                    alt: "arrow-buhta",
                                                    src: StaticAsset.src("/static/icons/Arrows.svg")
                                                  })
                                            ],
                                            className: "relative"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-10 items-center"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                    className: "mb-4 text-default-gray",
                                    children: "Приложения"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "mt-4 text-black",
                                            children: "Приложение"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    placeholder: "Выберите файл из шаблонов",
                                                    size: "m",
                                                    className: "w-112"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                    alt: "arrow-buhta",
                                                    src: StaticAsset.src("/static/icons/Arrows.svg")
                                                  })
                                            ],
                                            className: "relative"
                                          })
                                    ],
                                    className: "flex justify-between w-158 items-center mb-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Название"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            size: "m",
                                            className: "w-112",
                                            value: "Разработка дизайна корпоративного сайта"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "mt-4 text-black",
                                            children: "Номер"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-112 mb-1",
                                                    value: "ЧК-BUHTA-01"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                    className: "w-110 text-gray-medium",
                                                    children: "Если номер не последовательный или договор входящий, введите свой номер (последовательный все равно будет назначен, но использоваться будет введенный вами)."
                                                  })
                                            ],
                                            className: "flex-row"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-1 "
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Дата"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-43 absolute left-0",
                                                    value: "30.01.2022"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "mt-4 ml-4 text-black",
                                                    children: "Сроком до "
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-43 mb-2",
                                                    value: "30.01.2022"
                                                  })
                                            ],
                                            className: "flex justify-between w-112 relative"
                                          })
                                    ],
                                    className: "flex justify-between w-158  items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-black",
                                            children: "Счет"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    size: "m",
                                                    className: "w-112 ",
                                                    value: "KZ4829493091391039"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                    alt: "arrow-buhta",
                                                    src: StaticAsset.src("/static/icons/Arrows.svg")
                                                  })
                                            ],
                                            className: "relative"
                                          })
                                    ],
                                    className: "flex justify-between w-158 mb-10 items-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-8 h-10",
                                            src: StaticAsset.src("/static/icons/plus-bordered.svg")
                                          }),
                                      JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                            children: "Добавить приложение"
                                          })
                                    ],
                                    className: "flex gap-3 mt-6 mb-10 items-center"
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                    className: "w-full",
                                    children: "Сохранить"
                                  })
                            ],
                            className: "bg-white w-279 mt-10 rounded shadow-card p-10"
                          })
                    ],
                    className: "w-full flex flex-col items-center"
                  }),
              className: "bg-gray-pale"
            });
}

const make = ContractCreatePage;

export {
  make ,
}
/* Buhta_cabinet__Button Not a pure module */
